(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatch-loader"] && !Shopify.designMode) return;
  try {
    function extractColorName(inputString) {
  const knownColors = [
    "red", "orange", "yellow", "green", "blue", 
    "purple", "pink", "black", "white", "gray"
  ];

  knownColors.sort((a, b) => b.length - a.length)

  const regexPattern = new RegExp(`\\b(${knownColors.join('|')})\\b`, 'i')
  const match = inputString.match(regexPattern)

  return match ? match[0] : null
}

document.addEventListener('DOMContentLoaded', () => {
    
    // We only need to grab the selects. We will find their specific labels later.
    const selectElements = document.querySelectorAll('#simple-bundles-io-options select')
    
    let startedGroup = false;
    let swatchGroupLabel = null
    let swatchGroupStore = null
    let swatchGroupName = ""
    
    selectElements.forEach(selectElement => {

        // SAFETY CHECK: Ensure the element actually has an ID with a hyphen before splitting it
        let group = "group";
        let variant = "select";
        if (selectElement.id && selectElement.id.includes('---')) {
            const match = selectElement.id.match(/^(.*?)---(.*)$/)
            group = match[1].trim().replaceAll('-', ' '); 
            variant = match[2].trim().replaceAll('-', ' ')
        }else{
          group = selectElement.id.trim().replaceAll('-', ' ') 
        }
        selectElement.selectedIndex = 1
        if(startedGroup && swatchGroupName != group){
          startedGroup = false
        }
        if(group !== "required accessory"){
          if(!startedGroup){
            swatchGroupStore = document.createElement('div')
            swatchGroupStore.className = 'swatch-group'

            swatchGroupWrapper = document.createElement('div')
            swatchGroupWrapper.className = 'swatch-group-wrapper'          

            swatchGroupLabel = document.createElement('div')
            swatchGroupImage = document.createElement('div')

            swatchGroupLabel.className = 'swatch-group-label'
            swatchGroupLabel.textContent = group

            swatchGroupImage.className = 'swatch-group-image'
            swatchGroupImage.classList.add('swatch-group-image-' + group.replace(/[^a-zA-Z0-9\s]/g, '_').replace(/\s+/g, '-'));

            selectElement.parentNode.insertBefore(swatchGroupWrapper, selectElement.nextSibling)
            selectElement.parentNode.insertBefore(swatchGroupLabel, selectElement.nextSibling)

            swatchGroupWrapper.appendChild(swatchGroupImage)
            swatchGroupWrapper.appendChild(swatchGroupStore)

            startedGroup = true
          }
          
          swatchGroupName = group

          const swatchContainer = document.createElement('div')
          const swatchContainerGraphic = document.createElement('div')
          const swatchLabel = document.createElement('div')

          swatchContainer.className = 'swatch-container'

          swatchLabel.className = 'swatch-label'
          swatchLabel.textContent = variant
          
          // FIX: Search the entire document for the label using backticks for a clean string
          let aLabel = document.querySelector(`label[for*="${selectElement.id}" i]`)
          
          aLabel.style.display = 'none'
          selectElement.style.display = 'none'

          const swatches = [];

          Array.from(selectElement.options).forEach((option) => {
              if (!option.value || option.value === '') return;
              
              const swatch = document.createElement('button')
              swatch.type = 'button'
              swatch.title = option.text
              swatch.setAttribute('aria-label', `Select ${option.text}`)
              
              if (option.selected) {
                  swatch.classList.add('active');
              }
              
              var safeClassName = ""
              // Assign formatting based on whether it is a color dropdown or general dropdown
              if(selectElement.matches('[name*="color" i]')){
                  swatch.className = 'color-swatch';
                  
                  // Get the color, clean it, and handle instances where extractColorName might return null
                  let colorFound = extractColorName(option.value);
                  if (colorFound) {
                      safeClassName = colorFound.replace(/[^a-zA-Z0-9\s]/g, '_').replace(/\s+/g, '-');
                      swatch.classList.add('color-swatch-' + safeClassName);
                  }
              }else if(selectElement.matches('[name*="size" i]')){
                  swatch.className = 'size-swatch';
                  safeClassName = option.value.replace(/[^a-zA-Z0-9\s]/g, '_').replace(/\s+/g, '-');
                  swatch.classList.add('size-swatch-' + safeClassName);
              } else {
                  swatch.className = 'general-swatch';
                  safeClassName = option.value.replace(/[^a-zA-Z0-9\s]/g, '_').replace(/\s+/g, '-');
                  swatch.classList.add('general-swatch-' + safeClassName);
              }

              swatch.addEventListener('click', () => {
                  selectElement.value = option.value;
                  selectElement.dispatchEvent(new Event('change'));
                  swatchLabel.textContent = variant + " - " + safeClassName
                  // Remove 'active' from all swatches IN THIS SPECIFIC CONTAINER
                  swatches.forEach(s => s.classList.remove('active'));
                  swatch.classList.add('active');

              });
              if(option.selected){
                swatch.classList.add('active');
              }


              swatches.push(swatch);
              swatchContainer.appendChild(swatch);
          });
          swatchGroupStore.appendChild(swatchLabel)
          swatchGroupStore.appendChild(swatchContainer)
        } else{
          let aLabel = document.querySelector(`label[for*="${selectElement.id}" i]`);
          aLabel.style.display = 'none';
          selectElement.style.display = 'none';
        }
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-overlay"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("video-overlay")
  
  if (!overlay) return

  const video = document.getElementById("promo-video")

  document.body.appendChild(overlay)

  const delayBeforeShowing = parseInt(overlay.dataset.delayShowing, 10)
  const delayBeforeHiding = parseInt(overlay.dataset.delayHiding, 10)
  const delayBeforeReplay = parseInt(overlay.dataset.delayReplay, 10)

  const myTimer = setInterval(() => {
    playTimedOverlay()
  }, delayBeforeReplay)

  function playTimedOverlay(){
    setTimeout(() => {
      overlay.classList.add("active")
      
      video.play().catch(error => {
        console.log("Browser blocked autoplay:", error)
      })
    }, delayBeforeShowing)

    setTimeout(() => {
      overlay.classList.remove("active")
      video.pause()
      video.currentTime = 0
    }, delayBeforeHiding)
  }
  
  // Start the first loop
  playTimedOverlay()
});
  } catch(e) { console.error(e); }
})();

})();
